import * as React from 'react';
import { Button, Collapse, NavLink } from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import { NotificationCase } from './components/NotificationCase';
import { NotificationAlert } from './components/NotificationAlert';
import { NotificationType, INotification } from 'src/modules/Auth/store/types';
import { NotificationTransfer } from './components/NotificationTransfer';

export interface INotificationSectionProps {
  notifications: any;
  onDeleteNotification: () => void;
  toggle: () => void;
  collapse: boolean;
  type: string;
}

export class NotificationSection extends React.Component<INotificationSectionProps, any>{
  constructor(props: INotificationSectionProps) {
    super(props);
  }

  public getTitle(type: string) {
    const titles = {
      [NotificationType.Case]: `New cases`,
      [NotificationType.Alert]: `New alerts`,
      [NotificationType.Match]: `New matches`,
      [NotificationType.Crossborder]: `New transfers`
    }
    return titles[type];
  }

  public onDeleteNotification = (e) => {
    e.stopPropagation();
    this.props.onDeleteNotification();
  }

  public getComponentByPath(type: string, notificationKey: string, notification: INotification) {
    const notificationComponents = {
      [NotificationType.Case]: <NotificationCase key={notificationKey} notification={notification} />,
      [NotificationType.Alert]: <NotificationAlert key={notificationKey} notification={notification} />,
      [NotificationType.Match]: <NotificationCase key={notificationKey} notification={notification} />,
      [NotificationType.Crossborder]: <NotificationTransfer key={notificationKey} notification={notification} />
    }
    return notificationComponents[type];
  }

  public render() {
    const { notifications, toggle, collapse, type } = this.props;
    const notificationsData = Object.keys(notifications);
    const notificationTitle = this.getTitle(type)
    return (
      <>
        <div className="sidebar-link" onClick={toggle}>
          <NavLink active={collapse} className="container-header" >
            <h5>{notificationTitle}</h5>
            {notificationsData.length ?
              <Button className="btn-gray btn-notification-counter" >
                {notificationsData.length}
              </Button>
              : <></>}
          </NavLink>
        </div>
        <Collapse isOpen={collapse}>
          <div className="notification-view">
            {notificationsData.length > 0 && <p className="notification-remove" onClick={this.onDeleteNotification}>Clear</p>}
            <Scrollbars autoHeightMax={260} autoHeight={true}>
              {notificationsData.map(notificationKey => this.getComponentByPath(type, notificationKey, notifications[notificationKey]))}
              {notificationsData.length === 0 && <div className="no-notifications">No new notifications to display.</div>}
            </Scrollbars>
          </div>
        </Collapse>
      </>
    );
  }
}